var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-50 h-screen"},[_c('locale-changer',{attrs:{"custom-class":"bg-gray-50 absolute top-2 right-10"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }